var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.people),function(person){return _c('form-people-item',{key:person.id,attrs:{"person":person}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }